export default "__VITE_PUBLIC_ASSET__5dce115d__"